export default __webpack_public_path__ + "static/media/hero-agileSmall.7a25247b.jpg";